import { render, staticRenderFns } from "./StaffVacationTracker.vue?vue&type=template&id=52611644"
import script from "./StaffVacationTracker.vue?vue&type=script&lang=js"
export * from "./StaffVacationTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports